import { GenericService } from './generic.service';
import { Organisation } from '@/models';

export class CopdAssignableOrganisationService extends GenericService<Organisation> {
  endpoint = 'copd/assignable-organisations';
}
